import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import CalculationOverviewPage from "../CalculationOverview/CalculationOverviewPage";
import { Tender } from "@/graphql/__generated__/graphql";
import { useSearchParams } from "react-router-dom";

import { closeCalculationOverviewDialog, useCalculationOverviewDialogStore } from "@/store/calculationOverviewDialog";

interface CalculationOverviewWrapperDialogProps {
  organizationId?: number | null;
  tenderData?: Tender;
};

function CalculationOverviewWrapperDialog({ organizationId, tenderData }: CalculationOverviewWrapperDialogProps) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const isOpen = useCalculationOverviewDialogStore((state) => state.isOpen);
  const initialServiceId = useCalculationOverviewDialogStore((state) => state.initialServiceId);
  const initialOrganizationId = useCalculationOverviewDialogStore((state) => state.initialOrganizationId);
  const openDialog = useCalculationOverviewDialogStore((state) => state.openDialog);
  const operationalOrganizationId = searchParams.get("operationalOrganizationId");
  const resolvedInitialOrganizationId = initialOrganizationId ?? operationalOrganizationId ?? organizationId?.toString();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeCalculationOverviewDialog();
      return;
    }

    // Opened via the header trigger; don't overwrite any pre-set values.
    openDialog(initialServiceId, resolvedInitialOrganizationId);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          {t("components:calculationoverview.title")}
        </Button>
      </DialogTrigger>
      {isOpen && (
        <DialogContent className="max-w-[90vw] md:min-w-[90vw] p-4 pt-10 md:h-auto">
          <DialogTitle className="sr-only">{t("components:calculationoverview.title")}</DialogTitle>
          <DialogDescription className="sr-only">{t("components:calculationoverview.title")}</DialogDescription>
          <CalculationOverviewPage
            isDialog
            initialOrganizationId={resolvedInitialOrganizationId}
            initialServiceId={initialServiceId}
            tenderData={tenderData}
          />
        </DialogContent>
      )}
    </Dialog>
  );
}

export default CalculationOverviewWrapperDialog;
